import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfMileage } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

export const useListMileagesController = () => {
	const [mileagesData, setMileagesData] = useState<ModelOfMileage[]>([]);
	const [selectedMileage, setSelectedMileage] = useState<ModelOfMileage>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getMileages = () => {
		api.get(`mileages/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setMileagesData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeMileage = (mileage: ModelOfMileage) => {
		setLoading(true);
		api.delete(`mileages/${mileage.ID}`)
			.then(() => {
				getMileages();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O tipo de quilometragem foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getMileages();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editMileage = (mileage: ModelOfMileage) => {
		setLoading(true);

		const editedMileage: ModelOfMileage = {
			...mileage,
			ORGAO: userAgencyId,
		};

		api.put(`mileages/${selectedMileage?.ID}`, editedMileage)
			.then(() => {
				getMileages();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O tipo de quilometragem foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getMileages();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getMileages();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedMileage]);

	const openDeleteDialog = (mileage: ModelOfMileage) => {
		setDeleteDialog(true);
		setSelectedMileage(mileage);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (mileage: ModelOfMileage) => {
		setEditDialog(true);
		setSelectedMileage(mileage);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfMileage>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: async values => await editMileage(values),
		validationSchema,
	});

	return {
		getMileageListController: {
			formik,
			mileagesData,
			selectedMileage,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleMileageListController: {
			removeMileage,
			editMileage,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
		},
	};
};
